import { useCallback, useEffect, useState } from 'react';
import { getIsInternalUser } from '../utils';
export default function useDevtools() {
  const [isInternalUser] = useState(getIsInternalUser);
  const [isDevtoolsOpen, setIsDevtoolsOpen] = useState(false);
  const handleKeyDown = useCallback(e => {
    if (e.metaKey && e.code === 'Period') {
      e.preventDefault();
      setIsDevtoolsOpen(prev => !prev);
    } else if (e.code === 'Escape') {
      setIsDevtoolsOpen(false);
    }
  }, []);
  useEffect(() => {
    if (!isInternalUser) {
      return;
    }
    console.info('Collaboration Sidebar Devtools: Press Cmd + . to open');
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isInternalUser, handleKeyDown]);
  if (!isInternalUser) {
    return null;
  }
  return {
    isDevtoolsOpen,
    close: () => setIsDevtoolsOpen(false)
  };
}